import { PRIMARY_SURVEY_ID_SYSTEM } from './Attachment';

export type QuestionnaireSearchData = {
  hits: {
    hits: {
      _source: Pick<fhir.Questionnaire, 'title' | 'meta'>;
    }[];
  };
};

export const generateQuestionnaireSearchQuery = (
  primarySurveyIds: (string | undefined)[],
) => ({
  type: 'select',
  columns: ['title', 'meta'].map(field => ({
    expr: {
      type: 'column_ref',
      table: 'questionnaire',
      column: field,
    },
    as: field,
  })),
  from: [{ table: 'questionnaire' }],
  limit: [
    { type: 'number', value: 0 },
    { type: 'number', value: 1000 },
  ],
  where: {
    type: 'elasticsearch',
    query: {
      bool: {
        should: [
          ...primarySurveyIds.map(primarySurveyId => ({
            bool: {
              must: [
                {
                  term: {
                    'meta.tag.system.keyword': PRIMARY_SURVEY_ID_SYSTEM,
                  },
                },
                {
                  term: {
                    'meta.tag.code.keyword': primarySurveyId,
                  },
                },
              ],
            },
          })),
        ],
      },
    },
  },
});
